import { useGlobalData } from '@@app/hooks';

export const withGlobalData = (Component) => {
  return function WithGlobalData (props) {
    const {
      allowedPostalCodes,
      professionalSituations,
      regimeObligatoire,
      socioProfessionalCategories,
      activities,
      coverageZones,
      insurances,
      familySituations,
      organismCodes,
      phoneIndicatives,
      internationalPhoneIndicatives,
      productCode,
      activeUserInformation,
      viewMode,
      loadingGlobalData,
      usersInformation,
      getProject
    } = useGlobalData();

    if (loadingGlobalData) {
      return null;
    }

    return (
      <Component
        {...props}
        allowedPostalCodes={allowedPostalCodes}
        socioProfessionalCategories={socioProfessionalCategories}
        professionalSituations={professionalSituations}
        activities={activities}
        coverageZones={coverageZones}
        regimeObligatoire={regimeObligatoire}
        insurances={insurances}
        familySituations={familySituations}
        organismCodes={organismCodes}
        phoneIndicatives={phoneIndicatives}
        internationalPhoneIndicatives={internationalPhoneIndicatives}
        productCode={productCode}
        activeUserInformation={activeUserInformation}
        viewMode={viewMode}
        usersInformation={usersInformation}
        getProject={getProject}
      />
    );
  };
};

export default withGlobalData;
